import { Box, Paper, Typography, useTheme } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import type { ReactNode } from "react";

type Variant = "error" | "warning" | "info" | "success";

const VARIANT_TO_ICON: Record<Variant, ReactNode> = {
  info: <InfoOutlinedIcon />,
  error: <ErrorOutlineIcon />,
  warning: <WarningAmberOutlinedIcon />,
  success: <CheckCircleOutlineIcon />,
};
type Props = { variant: Variant; content: ReactNode };

export const InfoBox = ({ variant, content }: Props) => {
  const theme = useTheme();
  const icon = VARIANT_TO_ICON[variant];
  const { background, border } = theme.palette.infoBox[variant];

  return (
    <Paper
      sx={{
        p: 2,
        borderRadius: 2,
        backgroundColor: background,
        border: `1px solid ${border}`,
      }}
    >
      <Box display="flex" gap={2} alignItems="center">
        <Box
          display="flex"
          alignItems="center"
          sx={{ svg: { color: border, fontSize: 20 } }}
        >
          {icon}
        </Box>
        <Typography
          component="div"
          fontWeight={500}
          lineHeight="1.125rem"
          textAlign="left"
        >
          {content}
        </Typography>
      </Box>
    </Paper>
  );
};
